import { useMemo } from "react";
import createTranslator from "../../../util/translationHelper";
import messages from "./translations/messages";
import helper from "./pricingOptionHelper";

function usePricingOption(props) {
  const { type } = props;
  const translate = useMemo(() => createTranslator(messages), []);

  const label = translate(`${type}-plan`);
  const price = translate(`${type}-price`);
  const period = translate(`${type}-period`);
  const badge = helper.getBadgeText(type, translate);

  return {
    label,
    price,
    period,
    badge,
  };
}

const Hook = {
  usePricingOption,
};

export default Hook;
